import { Component, computed } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TenantDetailDto, TenantFilterDto, TenantItemDto, TenantService } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';

@Component({
  standalone: false,
  selector: 'wr-external-tenant-overview-page',
  templateUrl: './external-tenant-overview-page.component.html',
  styleUrls: ['./external-tenant-overview-page.component.scss'],
})
export class ExternalTenantOverviewPageComponent {
  canCreate = computed(() => this.currentUserService.hasPrivilege('canCreateExternalTenants'));
  form!: FormGroup;

  readonly loadTenants = (filter: TenantFilterDto) => this.tenantService.findAll({ ...filter, type: TenantDetailDto.TypeEnum.External });
  readonly getCount = (filter: TenantFilterDto) => this.tenantService.getCount({ ...filter, type: TenantDetailDto.TypeEnum.External });

  constructor(private readonly router: Router,
              private readonly tenantService: TenantService,
              private readonly formBuilder: FormBuilder,
              private readonly currentUserService: CurrentUserService
  ) {
    this.form = this.formBuilder.group({
      text: this.formBuilder.control(''),
    });
  }

  getQueryParams() {
    return { queryParams: { tenantType: 'external' } };
  }

  navigateToTenant(tenant: TenantItemDto): void {
    this.router.navigate(['tenant', tenant.id], this.getQueryParams());
  }

  readonly exportStreet = (tenant: TenantItemDto): string => {
    const address = tenant.paymentAddress;
    return address ? `${address.street} ${address.number}` : '';
  };

  readonly exportZip = (tenant: TenantItemDto): string => {
    const address = tenant.paymentAddress;
    return address ? `${address.country}-${address.zipCode}` : '';
  };

  add(): void {
    this.router.navigate(['tenant', 'new'], this.getQueryParams());
  }
}
